import jsPDF from "jspdf";

const PDF = (data) => {
  const doc = new jsPDF("portrait");
  doc.text(30, 15, data.topic);
  var splitTitle = doc.splitTextToSize(data.body, 270);
  doc.setFontSize("10");
  var y = 37;
  for (var i = 0; i < splitTitle.length; i++) {
    if (y > 280) {
      y = 10;
      doc.addPage();
    }
    doc.text(15, y, splitTitle[i]);
    y = y + 7;
  }
  doc.save(data.topic + '.pdf');
}

export default PDF;

